var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 18.6667V5.33333C21.6666 2.44267 16.7826 0 10.9999 0C5.21725 0 0.333252 2.44267 0.333252 5.33333V18.6667C0.333252 21.5573 5.21725 24 10.9999 24C16.7826 24 21.6666 21.5573 21.6666 18.6667ZM10.9999 2.66667C15.9213 2.66667 18.9079 4.676 18.9999 5.32533C18.9079 5.99067 15.9213 8 10.9999 8C6.07859 8 3.09192 5.99067 2.99992 5.34133C3.09192 4.676 6.07859 2.66667 10.9999 2.66667ZM2.99992 8.80933C4.97192 9.93867 7.84925 10.6667 10.9999 10.6667C14.1506 10.6667 17.0279 9.93867 18.9999 8.80933V11.992C18.9079 12.6573 15.9213 14.6667 10.9999 14.6667C6.07859 14.6667 3.09192 12.6573 2.99992 12V8.80933ZM2.99992 18.6667V15.476C4.97192 16.6053 7.84925 17.3333 10.9999 17.3333C14.1506 17.3333 17.0279 16.6053 18.9999 15.476V18.6587C18.9079 19.324 15.9213 21.3333 10.9999 21.3333C6.07859 21.3333 3.09192 19.324 2.99992 18.6667Z",
    fill: "#0036A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb);
export default __webpack_public_path__ + "static/media/Db.05c56975a1e7806e84d87e8eb7d07789.svg";
export { ForwardRef as ReactComponent };